"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoClosurePayoffMethod = exports.CryptoClosureError = void 0;
var CryptoClosureError;
(function (CryptoClosureError) {
    CryptoClosureError["activeRequestExists"] = "activeRequestExists";
    CryptoClosureError["notEligible"] = "notEligible";
    CryptoClosureError["btcPriceUnavailable"] = "btcPriceUnavailable";
    CryptoClosureError["balanceRequiresPayoff"] = "balanceRequiresPayoff";
    CryptoClosureError["noActiveRequest"] = "noActiveRequest";
    CryptoClosureError["liquidationInProgress"] = "liquidationInProgress";
    // A co owner (non borrowing party) cannot unilaterally initiate account closure.
    // Distinct from notEligible, which is about the account rather than the caller.
    CryptoClosureError["notAuthorizedHolder"] = "notAuthorizedHolder";
})(CryptoClosureError || (exports.CryptoClosureError = CryptoClosureError = {}));
var CryptoClosurePayoffMethod;
(function (CryptoClosurePayoffMethod) {
    CryptoClosurePayoffMethod["NONE"] = "none";
    CryptoClosurePayoffMethod["WIRE_TRANSFER"] = "wire_transfer";
    CryptoClosurePayoffMethod["LIQUIDATE_BTC"] = "liquidate_btc";
})(CryptoClosurePayoffMethod || (exports.CryptoClosurePayoffMethod = CryptoClosurePayoffMethod = {}));
